
import { getAll } from "@/utilities/querySelector";

getAll( '.staggered-section .play-video' ).forEach( playButton => {
    playButton.addEventListener( 'click', function() {
        const video = /** @type {HTMLVideoElement} */( playButton.previousElementSibling );
        video?.play();
        video?.setAttribute( 'controls', 'true' );
        jQuery( playButton ).fadeOut();
    } );
} );
